import { reset as classroomReset, getClassrooms } from '../redux/classrooms/actions'
import { getLicenses } from '../redux/licenses/actions'
import { getStore } from '../redux/store' 

const store = getStore()

global.otuApp.resetAppState = () => {
  if (license.isTeacher()){
    store.dispatch( classroomReset() )
    store.dispatch( getClassrooms() )
  }
}
